import { Outlet } from 'react-router-dom';

import { useGlobalStore } from '@dmp/stores';
import {
  checkAndRefreshToken,
  getIsLoggedIn,
  getShouldRefreshToken,
  isTokenExpired,
  redirectToLandingPageAndClearCache,
  reLogin,
} from '@dmp/utils/auth';

import { useIdleCheckTokenResetPage } from './RouteGuard.hooks';

// render twice if use lazy import
export const RouteGuard = () => {
  useIdleCheckTokenResetPage();
  const enforce_login = useGlobalStore((s) => s.tenantConfig?.enforce_login);

  const shouldRefreshToken = getShouldRefreshToken();
  const isLoggedIn = getIsLoggedIn();

  if (enforce_login) {
    if (
      !isLoggedIn ||
      (isLoggedIn && isTokenExpired() && !shouldRefreshToken) // no cached refresh token to silently renew with
    ) {
      reLogin();
      return null;
    }
  } else if (
    isLoggedIn &&
    isTokenExpired() &&
    !shouldRefreshToken // no cached refresh token to silently renew with (e.g. never fully logged in)
  ) {
    redirectToLandingPageAndClearCache();
    return null;
  }

  if (isLoggedIn && shouldRefreshToken) {
    checkAndRefreshToken();
  }

  return <Outlet />;
};
